module.exports = __webpack_public_path__ + "static/logo-lehand-5f952cb3bb9e684530e7714f46f6f45d.svg";